precision mediump float;
varying vec2 st;

uniform float time;
uniform float scrollY;
uniform float width;
uniform float height;
uniform float pageHeight;
uniform float speed;
uniform float scale;
uniform float verticalRange;

struct point {
  vec2 position;
  vec3 color;
  vec2 seed;
};

struct section {
  float start;
	float end;
  vec3 color;
};

uniform int numPoints; 
uniform point points[32];

uniform int numSections; 
uniform section sections[32];

vec4 getSectionColor(vec3 c) {
	if(c.x < 0.){
		return vec4(points[0].color, 1.);
	}
	return vec4(c, 1.);
}


/**
* @typedef {struct} gln_tFBMOpts   Options for fBm generators.
* @property {float} seed           Seed for PRNG generation.
* @property {float} persistance    Factor by which successive layers of noise
* will decrease in amplitude.
* @property {float} lacunarity     Factor by which successive layers of noise
* will increase in frequency.
* @property {float} scale          "Zoom level" of generated noise.
* @property {float} redistribution Flatness in the generated noise.
* @property {int} octaves          Number of layers of noise to stack.
* @property {boolean} terbulance   Enable terbulance
* @property {boolean} ridge        Convert the fBm to Ridge Noise. Only works
* when "terbulance" is set to true.
*/


void main() {
  vec4 color = getSectionColor(sections[0].color);

  float scrollPercent = scrollY / pageHeight;
  float heightPercentRange = height / pageHeight;
  float t = time * speed;
	float scaledNoise = mix(.2, 1., max(width / 1200., 1.));
	float scrolledYValue = (scrollPercent + st.y * heightPercentRange) / heightPercentRange;

	gln_tFBMOpts opts = gln_tFBMOpts(points[0].seed.x, .1, 1.3, scaledNoise, 1.0, 2, false, false);
  float noise = gln_sfbm(vec3( st.x, scrolledYValue, t), opts) * 1.3;

	
  if (numSections > 1) {    
		for (int i = 0; i < 31; i++) {
			if (i < numSections - 1) {
				bool multi = sections[i].color.x == -1.;
				
				//start -> end: fill color
				color = mix(color, getSectionColor(sections[i].color), smoothstep(
					sections[i].start,
					sections[i].end, 
					scrollPercent - (( -st.y + (noise * verticalRange)) * heightPercentRange)
				));
				
				if(multi){
					// color = vec4(points[0].color, 1.);
					for(int p = 0; p< 64; p++){
						if(p < numPoints){
							float x = getSin(time, -.1, 1.1, 50. / points[p].seed.x, points[p].seed.x * 2000.);
							float start = sections[i].start / heightPercentRange;
							float end = sections[i].end / heightPercentRange;
							float y = getCos(time, start, end, 40. / points[p].seed.y, points[p].seed.y * 2000.);
							y -= scrollPercent / heightPercentRange;
							float dist = distance(vec2(st.x * width, st.y * height), vec2(x * width, y * height)) ;
							//this adjusts the overall scale of the blobs, it's responsive to the width and height of the page so sensitive to dial in
							float strength = smoothstep(0., 1.,  1.8 - dist / (width + height) * 7.6 );
							color = mix(color, vec4(points[p].color, 1.), strength );
						}
					}
				}

				//end -> start of next: transitions color
				color = mix(color, getSectionColor(sections[i + 1].color), smoothstep(
					sections[i].end,
					sections[i + 1].start, 
					scrollPercent - (( -st.y + (noise * verticalRange)) * heightPercentRange)
				));
			} else { break; }
		}
  }

  gl_FragColor = color;
}